import { api } from "./api";

// ---- UTM capture + attribution ----
const SESSION_KEY = "agni_session";
const ATTR_KEY = "agni_attribution";

export function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];
  const found = {};
  keys.forEach((k) => { if (params.get(k)) found[k] = params.get(k); });
  const hasNew = Object.keys(found).length > 0;
  let stored = {};
  try { stored = JSON.parse(localStorage.getItem(ATTR_KEY) || "{}"); } catch (e) {}
  if (hasNew || !stored.landing_page) {
    const attr = {
      ...found,
      landing_page: stored.landing_page || window.location.pathname,
      referrer: stored.referrer || document.referrer || "",
      session_id: getSessionId(),
    };
    localStorage.setItem(ATTR_KEY, JSON.stringify(attr));
    api.post("/track/attribution", attr).catch(() => {});
  }
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem(ATTR_KEY) || "{}"); } catch (e) { return {}; }
}

// ---- Marketing pixels / analytics ----
let TRACKING = {};
export function initTracking(settings) {
  TRACKING = settings || {};
  if (!TRACKING.enabled) return;
  injectPixels();
}

function injectOnce(id, fn) {
  if (document.getElementById(id)) return;
  fn();
}

function injectPixels() {
  const { meta_pixel_id, ga4_id, gtm_id, head_scripts, footer_scripts } = TRACKING;
  if (meta_pixel_id) {
    injectOnce("meta-pixel", () => {
      const s = document.createElement("script");
      s.id = "meta-pixel";
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${meta_pixel_id}');fbq('track','PageView');`;
      document.head.appendChild(s);
    });
  }
  if (ga4_id) {
    injectOnce("ga4", () => {
      const s = document.createElement("script");
      s.id = "ga4"; s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4_id}`;
      document.head.appendChild(s);
      const c = document.createElement("script");
      c.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${ga4_id}');`;
      document.head.appendChild(c);
    });
  }
  if (gtm_id) {
    injectOnce("gtm", () => {
      const s = document.createElement("script");
      s.id = "gtm";
      s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f)})(window,document,'script','dataLayer','${gtm_id}');`;
      document.head.appendChild(s);
    });
  }
  if (head_scripts) injectOnce("custom-head", () => {
    const d = document.createElement("div"); d.id = "custom-head"; d.innerHTML = head_scripts;
    Array.from(d.childNodes).forEach((n) => document.head.appendChild(n));
  });
  if (footer_scripts) injectOnce("custom-footer", () => {
    const d = document.createElement("div"); d.id = "custom-footer"; d.innerHTML = footer_scripts;
    Array.from(d.childNodes).forEach((n) => document.body.appendChild(n));
  });
}

// Event map: our event -> [meta event, ga4 event]
const EVENT_MAP = {
  PageView: ["PageView", "page_view"],
  ViewContent: ["ViewContent", "view_item"],
  Lead: ["Lead", "generate_lead"],
  InitiateCheckout: ["InitiateCheckout", "begin_checkout"],
  AddPaymentInfo: ["AddPaymentInfo", "add_payment_info"],
  Purchase: ["Purchase", "purchase"],
  CompleteRegistration: ["CompleteRegistration", "sign_up"],
  Login: [null, "login"],
  StartTest: [null, "start_test"],
  CompleteTest: [null, "complete_test"],
};

export function track(event, props = {}) {
  const [metaEvt, gaEvt] = EVENT_MAP[event] || [event, event];
  try {
    if (window.fbq && metaEvt) window.fbq("track", metaEvt, props);
    if (window.gtag && gaEvt) window.gtag("event", gaEvt, props);
    if (window.dataLayer) window.dataLayer.push({ event: gaEvt || event, ...props });
  } catch (e) {}
  api.post("/track/event", { event, props, session_id: getSessionId() }).catch(() => {});
}
